import { z } from "zod";

const toTrimmedString = (value) => String(value ?? "").trim();

const normalizeEmail = (value) => toTrimmedString(value).toLowerCase();
const normalizeMobile = (value) => toTrimmedString(value).replace(/\D/g, "");

const emptyToUndefined = (value) => {
  const str = toTrimmedString(value);
  return str.length ? str : undefined;
};

export const buildUserSchema = ({ showPasswordField = false, passwordRequired = false } = {}) => {
  return z
    .object({
      full_name: z.preprocess(
        toTrimmedString,
        z.string().min(1, "Full name is required.")
      ),
      email_id: z
        .preprocess(normalizeEmail, z.string().email("Please enter a valid email address.")),
      mobile_number: z
        .preprocess(normalizeMobile, z.string().regex(/^\d{10}$/, "Mobile number must be exactly 10 digits.")),
      gender: z.preprocess(emptyToUndefined, z.string().optional()).default("Male"),
      primary_role: z.preprocess(toTrimmedString, z.string().min(1, "Primary Role is required.")),
      secondary_role: z.preprocess(toTrimmedString, z.string().optional()).default(""),
      system_role: z.preprocess(toTrimmedString, z.string().optional()).default(""),
      has_portal_access: z.boolean().optional().default(false),
      os_type: z.preprocess(emptyToUndefined, z.string().optional()).default("Android"),
      password_hash: z.preprocess(toTrimmedString, z.string().optional()).default(""),
      society_id: z.preprocess(emptyToUndefined, z.string().optional()).default(""),
      role_details: z.any().optional(),
    })
    .superRefine((data, ctx) => {
      const isSystemRole =
        String(data.primary_role || "").toLowerCase() === "system" ||
        Boolean(String(data.system_role || "").trim());

      if (!isSystemRole && (!data.society_id || !String(data.society_id).trim())) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["society_id"],
          message: "Please select a property/society.",
        });
      }

      if (showPasswordField && passwordRequired && !String(data.password_hash || "").trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["password_hash"],
          message: "Password is required for dashboard users.",
        });
      }
    });
};

